<div class="weekly-modal" *ngIf="taskGanttData">
  <div class="loader-wrapper-modal" *ngIf="loading">
    <tui-loader size="l"></tui-loader>
  </div>

  <!-- Mensaje de “no data” si hubo error/cero datos -->
  <div class="no-data-msg-modal" *ngIf="!loading && noData">
    {{ "service_manager.modal.no_data_found" | translate }}
  </div>

  <ng-container *ngIf="!loading && !noData">
    <!-- close --------------------------------------------------------->
    <div class="weekly-modal-header">
      <!-- header ------------------------------------------------------>
      <div class="header-left">
        <div class="service">
          <span
            class="service-name"
            *ngIf="taskGanttData.nodeType === 'OPERATIVE_NODE'"
          >
            {{ taskGanttData.productName }}
          </span>
          <span
            class="service-name"
            *ngIf="taskGanttData.nodeType === 'SWEEPER_NODE'"
          >
            {{ "service_manager.modal.sweeper_car" | translate }}
          </span>
          <span
            class="service-name"
            *ngIf="taskGanttData.nodeType === 'TRANSPORT_NODE'"
          >
            {{ "service_manager.modal.public_transport" | translate }}
          </span>

          <ng-container *ngIf="taskGanttData.nodeType !== 'TRANSPORT_NODE'">
            <div class="mt-2">
              <div class="mt-1">
                <span class="fw-bold">Order hash: </span>
                <span class="service-hash">{{ taskGanttData.orderHash }}</span>
              </div>
              <div class="mt-1">
                <span class="service-product">
                  {{ taskGanttData.licensePlate }} –
                  {{ taskGanttData.vehicleChassis }}
                </span>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="mt-1">
          <tui-badge
            *ngIf="taskGanttData?.orderStatus | orderStatusBadge as cfg"
            [status]="cfg.tuiStatus"
            [value]="cfg.key | translate"
            class="badge"
            [ngClass]="cfg.cssClass"
          >
          </tui-badge>
        </div>
      </div>

      <div class="header-right">
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="closeModal()"
        ></button>
      </div>
    </div>

    <!-- body ---------------------------------------------------------->
    <section class="body">
      <!-- client / driver ------------------------------------------->
      <div class="row-flex" *ngIf="!isTransportNode">
        <div class="flex-icon">
          <tui-svg src="tuiIconUser"></tui-svg>
          <span class="label fw-bold">
            {{ participantLabelKey | translate }}:
          </span>
        </div>
        <span>{{ participantName }}</span>
      </div>

      <!-- pickup time ----------------------------------------------->
      <div class="row-flex">
        <div class="flex-icon">
          <tui-svg src="tuiIconClock"></tui-svg>
          <span class="label fw-bold">
            {{ "service_manager.modal.pickup_time" | translate }}:
          </span>
        </div>
        <span>{{
          getFormattedTime(taskGanttData.serviceStartDate.seconds)
        }}</span>
      </div>

      <!-- eta (only sweeper / transport) --------------------------->
      <div class="row-flex" *ngIf="taskGanttData.nodeType !== 'OPERATIVE_NODE'">
        <div class="flex-icon">
          <tui-svg src="tuiIconMapPin"></tui-svg>
          <span class="label fw-bold">
            {{ "service_manager.modal.estimated_arrival_time" | translate }}:
          </span>
        </div>
        <span>{{
          getFormattedTime(taskGanttData.serviceEndDate.seconds)
        }}</span>
      </div>

      <!-- start ----------------------------------------------------->
      <div class="row-flex">
        <div class="flex-icon">
          <tui-svg src="tuiIconMapPin"></tui-svg>

          <span class="label fw-bold">
            {{ "service_manager.modal.pickup_point" | translate }}:
          </span>
        </div>
        <span>{{ taskGanttDataDetails.startUbication.address }}</span>
      </div>

      <!-- providers ------------------------------------------------->
      <ng-container *ngIf="taskGanttDataDetails?.providersUbication?.length">
        <div
          class="row-flex"
          *ngFor="
            let ub of taskGanttDataDetails.providersUbication;
            let i = index
          "
        >
          <div class="flex-icon">
            <tui-svg src="tuiIconMapPin"></tui-svg>

            <span class="label fw-bold">
              {{ "service_manager.modal.provider_point" | translate }}
              <ng-container
                *ngIf="taskGanttDataDetails.providersUbication.length > 1"
              >
                #{{ i + 1 }} </ng-container
              >:
            </span>
          </div>
          <span>{{ ub.address }}</span>
        </div>
      </ng-container>

      <!-- end ------------------------------------------------------->
      <div class="row-flex">
        <div class="flex-icon">
          <tui-svg src="tuiIconMapPin"></tui-svg>
          <span class="label fw-bold">
            {{ "service_manager.modal.dropoff_point" | translate }}:
          </span>
        </div>
        <span>{{ taskGanttDataDetails.endUbication.address }}</span>
      </div>
    </section>

    <!-- map --------------------------------------------------------->

    <div class="map-wrapper">
      <div #littleGmapContainer class="map"></div>
    </div>

    <!-- node-lock block -------------------------------------------->

    <div
      *ngIf="taskGanttDataDetails && hasDriverAssigned"
      class="mt-3 lock-driver-container"
    >
      <!-- Node Lock Toggle with Loader -->
      <div [attr.aria-busy]="loading">
        <label class="d-flex align-items-center gap-2 mb-0">
          <tui-toggle
            [ngModel]="isNodeLockedForDriverAssignation"
            (ngModelChange)="onToggle($event)"
            size="l"
            class="custom-toogle"
          >
          </tui-toggle>
          <span class="fw-semibold">
            {{ "service_manager.modal.node_locked" | translate }}
          </span>
        </label>

        <!-- Inline loader while HTTP request is in flight -->
        <tui-loader
          *ngIf="nodeStatusLoading"
          size="s"
          class="ms-2"
        ></tui-loader>
      </div>

      <!-- Explanatory helper text -->
      <p class="text-secondary small mt-1">
        {{ "service_manager.modal.node_locked_hint" | translate }}
      </p>
    </div>

    <!-- footer ------------------------------------------------------>
    <footer class="footer" *ngIf="taskGanttData.nodeType !== 'TRANSPORT_NODE'">
      <button class="btn btn-primary w-100" (click)="viewDetail()">
        {{ "service_manager.modal.view_service_details" | translate }}
      </button>
    </footer>
  </ng-container>
</div>
